<template>
    <div id="hospDetail" class="sys-page">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item to="/hospManage">医院管理</el-breadcrumb-item>
                <el-breadcrumb-item>医院信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card class="box-card">
            <p class="title">
                医院信息
                <img src="../assets/edit.png" class="editMsg" title="编辑" @click="editHospMsg()" alt="">
            </p>
            <div>
                <div class="list">
                    <span class="keyWord">医院编号 : </span><span class="contents">{{hospMsg.hospCode}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院名称 : </span><span class="contents">{{hospMsg.hospName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院负责人 : </span><span class="contents">{{hospMsg.hospAdminName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院电话 : </span><span class="contents">{{hospMsg.hospAdminTel}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">接诊咨询人 : </span><span class="contents">{{hospMsg.receiveName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">接诊咨询电话 : </span><span class="contents">{{hospMsg.receiveTel}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院等级 : </span><span class="contents">{{hospMsg.hospRank}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院地址 : </span><span class="contents">{{hospMsg.hospAddr}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院简介 : </span><span class="contents">{{hospMsg.hospDesc}}</span>
                </div>
                <!-- <div class="statePic" @click="staticTo()">统计大屏</div> -->
            </div> 
            <p class="title">管理员信息</p>
            <div style="text-align:left"> 
                <el-button type="primary" size="small" style="margin-left:20px;" v-show="!flag" @click="addAdminDialog=true">创建管理员</el-button>
                <p class="list" v-show="flag">管理员姓名 ：{{adminMsg.userName}}</p>
                <p class="list" v-show="flag">管理员账号 ：{{adminMsg.userTel}} <span class="editPwd" @click="resetPassword()">重置密码</span></p>
                <el-button type="primary" size="small" style="margin-left:20px;" @click="$router.push({path:'/docAdmin'})">医生管理</el-button>
            </div>
        </el-card>
        <el-card class="box-card">
            <p class="title">转诊医院</p>
            <div style="margin:10px 0" align="left">
                <el-row :gutter="10">
                    <el-col align="left" :span="16">
                        <el-button type="primary"  @click="addDialog = true" size="small">添加转诊医院</el-button>
                    </el-col>
                    <el-col align="center" :span="7">
                        <el-input v-model="hospName" size="small" placeholder="医院名称" clearable @keyup.enter.native="getHospList(1)"></el-input>
                    </el-col>
                        <el-col align="center" :span="1">
                        <el-button icon="el-icon-search" type="success" size="small" circle @click="getHospList(1)"></el-button>
                    </el-col>
                </el-row>
            </div>
            <div>
                <template class="tableList">
                    <el-table :data="hospList.body" ref="hospList"  style="width: 100%">
                        <el-table-column type="index" align="center" label="序号" > </el-table-column>
                        <el-table-column prop="hospName" align="center" label="医院名称" > </el-table-column>
                        <!-- <el-table-column prop="hospCode" align="center" label="医院编号" > </el-table-column> -->
                        <el-table-column prop="hospAdminName" align="center" label="医院负责人" > </el-table-column>
                        <el-table-column prop="hospAdminTel" align="center" label="医院联系电话"></el-table-column>
                        <el-table-column prop="receiveName" align="center" label="接诊咨询人"></el-table-column>
                        <el-table-column prop="receiveTel" align="center" label="接诊咨询电话"></el-table-column>
                        <el-table-column prop="hospRank" align="center" label="等级"></el-table-column>
                        <el-table-column prop="hospAddr" align="center" label="地址"></el-table-column>
                        <el-table-column align="center" label="操作" >
                            <template slot-scope="scope">
                                <el-button type="text"  style="color:red" @click="delParent(scope.row)">禁 用</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="page">
                <el-pagination  :page-size="rowsList" :page-count="5" layout="total, prev, pager, next" :page-sizes="[50,100]" :total="hospList.count" @current-change='changePage' @size-change="changeSizeL" style="text-align:right"></el-pagination>
            </div>
        </el-card>
        
        <!-- 修改医院信息弹窗 -->
        <el-dialog title="修改医院" :visible.sync="editHosp" :close-on-press-escape=false width="660px">
            <el-form :model="editMsg" ref="editMsg" label-width="110px">
                <el-form-item label="医院名称">
                    <el-input v-model="editMsg.hospName" placeholder="医院名称" maxlength="25"></el-input>
                </el-form-item>
                <el-form-item label="医院联系电话">
                    <el-input v-model="editMsg.hospAdminTel" placeholder="医院联系电话"></el-input>
                </el-form-item>
                <el-form-item label="医院负责人">
                    <el-input v-model="editMsg.hospAdminName" placeholder="医院负责人"></el-input>
                </el-form-item>
                <el-form-item label="接诊咨询人">
                    <el-input v-model="editMsg.receiveName" placeholder="接诊咨询人"></el-input>
                </el-form-item>
                <el-form-item label="接诊咨询电话">
                    <el-input v-model="editMsg.receiveTel" placeholder="接诊咨询电话"></el-input>
                </el-form-item>
                <el-form-item label="医院地址">
                    {{editMsg.hospRegionAddr}}
                </el-form-item>
                <el-form-item label="详细地址">
                    <el-input v-model="editMsg.hospAddr" placeholder="详细地址"></el-input>
                </el-form-item>
                <el-form-item label="等级" prop="hospRank">
                    <el-select v-model="editMsg.hospRank" placeholder="等级" style="width:100%">
                        <el-option v-for="item in hospRanks" :label="item.dictDesc" :value="item.dictDesc" :key="item.dictDesc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="简介">
                    <el-input v-model="editMsg.hospDesc" type="textarea" :rows="4" placeholder="简介"></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="cancel()">取 消</el-button>
            <el-button type="primary" @click="update()">确定</el-button>
        </el-dialog>
        <!-- 添加管理员弹窗 -->
        <el-dialog title="添加管理员" :visible.sync="addAdminDialog" :close-on-press-escape=false width="700px"> 
            <el-form :model="addAdminForm" :rules="addAdminFormRules" ref="addAdminForm" label-width="100px">
                <el-form-item label="管理员电话" prop='docPhone'>
                    <el-input v-model="addAdminForm.docPhone" placeholder="管理员电话"></el-input>
                </el-form-item>
                <el-form-item label="管理员姓名" prop='docName'>
                    <el-input v-model="addAdminForm.docName" :disabled="disabled" placeholder="管理员姓名"></el-input>
                </el-form-item>
                <el-form-item label="管理员密码" prop='password'>
                    <el-input v-model="addAdminForm.password" :disabled="disabled" :type="type" placeholder="管理员密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop='passwordTwo'>
                    <el-input v-model="addAdminForm.passwordTwo" :disabled="disabled" :type="type" placeholder="再次输入密码"></el-input>
                </el-form-item>
                <div style="display:flex;justify-content:flex-end">
                    <el-button @click="cancel()">取 消</el-button>
                    <el-button type="primary" @click="saveAdmin('addAdminForm')">确定</el-button>
                </div>
            </el-form>
            
        </el-dialog>
        <!-- 添加关联医院弹窗 -->
        <el-dialog title="添加转诊医院" :visible.sync="addDialog" width="700px">
            <el-row>
                <el-col align="center" :span="21">
                    <el-input v-model="addHosp.hospName" placeholder="医院名称" clearable @keyup.enter.native="getUnHospList()"></el-input>
                </el-col>
                    <el-col align="center" :span="3">
                    <el-button circle icon="el-icon-search" @click="getUnHospList()"></el-button>
                </el-col>
            </el-row>
            <el-table :data="addHosp.body"  style="width: 100%">
                <el-table-column type="index" align="center" label="序号" > </el-table-column>
                <el-table-column prop="hospName" align="center" label="医院名称" > </el-table-column>
                <el-table-column prop="hospAdminName" align="center" label="医院负责人" > </el-table-column>
                <el-table-column prop="hospAdminTel" align="center" label="医院联系电话"></el-table-column>
                <el-table-column align="center" label="操作" >
                    <template slot-scope="scope">
                        <el-button type="text" @click="addParentHosp(scope.row)">添 加</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="height:10px;"></div>
            <el-button @click="cancel()">取 消</el-button>
        </el-dialog>
    </div>
</template>

<script>
import {isvalidCallAndPhone,isvalidPhone} from '@/service/common'
import { Loading } from 'element-ui'
var validPhoneAcall=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入手机号码'))
    }else  if (!isvalidCallAndPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
var validPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入手机号码'))
    }else  if (!isvalidPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
export default {
    name:'hospDetail',
    data(){
        return{
            //医院信息
            hospMsg:{},
            hospRanks:[],//医院 级别
            //医院管理员信息
            adminMsg:{
                userName:'',
                userTel:''
            },
            //医院信息编辑
            editMsg:{
                hospId:'',
                hospCode:'',
                hospName:'',
                hospAddr:'',
                hospRank:'',
                hospDesc:'',
                hospRegionAddr:'',
                hospAdminName:'',
                hospAdminTel:'',
                receiveName:'',
                receiveTel:'',
            },
            //医院信息编辑规则
            editMsgRules:{
                hospAdminName:[{required: true, message: '请输入医院负责人姓名', trigger: 'blur'}],
                hospAdminTel:[{ required: true, trigger: 'blur', validator: validPhoneAcall }],
                hospAddr:[{required: true, message: '请输入医院详细地址', trigger: 'blur'}],
            },
            disabled:false,
            type:'password',
            editHosp:false,//医院信息编辑
            flag:false,//是否有管理员
            addAdminDialog:false,//创建管理员
            addDialog:false,//添加下级医院弹窗
            //创建医院 管理员
            addAdminForm:{
                docName:'',
                docPhone:'',
                password:'',
                passwordTwo:''
            },
            //创建管理员规则
            addAdminFormRules:{
                docName:[{required: true, message: '请输入医院管理员姓名', trigger: 'blur'}],
                docPhone:[{ required: true, trigger: 'blur', validator: validPhone }],
                password:[{required: true, message: '请输入密码', trigger: 'blur'},{min:6,message: '密码不得小于6位', trigger: 'blur'}],
                passwordTwo:[{required: true, message: '请再次输入密码', trigger: 'blur'},{min:6,message: '密码不得小于6位', trigger: 'blur'}],
            },
            //编辑账户信息
            editCharMsg:{
                hospId:'',
                chargeStatus:'02',
                standardPrice:0,
                chargeRule:{
                    CT:0,
                    CR:0,
                    DR:0,
                    MR:0
                }
            },
            //账户信息
            balanceMsg:{
                standardPrice:0,
                chargeStatus:'01',
                chargeRule:{
                    CT:0,
                    CR:0,
                    DR:0,
                    MR:0
                }
            },
            //下级医院列表
            hospList:{
                body:[],
                count:0,
                page:1
            },
            hospName:'',//名称查询下级医院
            //未添加的医院列表
            addHosp:{
                hospName:'',
                body:[],
                count:0
            },
            //下级医院收费设置
            childCharg:{
                hospId:'',
                hospCode:'',
                hospName:'',
                hospRank:'',
                priceDif:''
            },
            rowsDialog:50,
            rowsList:50,
            loadingInstance:''
        }
    },
    mounted(){
        this.hospMsg=this.$common.getStorage('hospMsg');
        this.getHospDetail(this.hospMsg.hospId);
        this.getHospList(1);
        this.listHospRank()
    },
    methods:{
        //查询医院详情
        getHospDetail(hospId){
            this.$ajax.post(this.$domain.getHospDetail,{
                hospId:hospId
            })
            .then(ret=>{
                this.$common.getConsole('hospDetail.vue——查询医院详情',ret.data)
                if(ret.data.code==200){
                    this.hospMsg=ret.data.data;
                    this.getAdminInfo(this.hospMsg);
                }
                else if(res.code=='502'){
                    this.$message.error('登录失败，请重新登录！');
                    this.$router.push({path:"/login"});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //获得医院等级列表
        listHospRank(){
            this.$ajax.post(this.$domain.listHospRank)
            .then((ret)=>{
                var res=ret.data;
                if(res.code=="200"){
                    this.hospRanks=res.data
                }
                else if(res.code=='502'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
            })
        },
        //点击修改医院信息
        editHospMsg(){
            this.editHosp=true;
            this.editMsg={
                hospId:this.hospMsg.hospId,
                hospCode:this.hospMsg.hospCode,
                hospName:this.hospMsg.hospName,
                hospAddr:this.hospMsg.hospAddr,
                hospRank:this.hospMsg.hospRank,
                hospDesc:this.hospMsg.hospDesc,
                hospRegionAddr:this.hospMsg.hospRegionAddr,
                hospAdminName:this.hospMsg.hospAdminName,
                hospAdminTel:this.hospMsg.hospAdminTel,
                receiveName:this.hospMsg.receiveName,
                receiveTel:this.hospMsg.receiveTel,
            }
        },
        // 保存修改医院信息
        update(){
            this.$refs['editMsg'].validate((valid) => {
                if(valid){
                    this.loadingInstance=Loading.service({
                        text:'医院信息保存中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    this.$ajax.post(this.$domain.updateHosp,this.editMsg)
                    .then(ret=>{
                        this.loadingInstance.close();
                        var res=ret.data;
                        this.$common.getConsole('hospDetail.vue——保存修改医院信息',res)
                        if(res.code=="200"){
                            this.$message.success('修改成功！');
                            this.getHospDetail(this.hospMsg.hospId)
                            this.cancel();
                        }
                        else if(res.code=='502'){
                            this.$message.error('登录失败，请重新登录！');
                            this.$router.push({path:"/login"});
                        }
                        else{
                            this.$message.error('修改失败！');
                        }
                    })
                    .catch(err=>{
                        this.$common.getConsole('hospDetail.vue——保存修改医院信息catch',err)
                        this.loadingInstance.close();
                    })
                }
                else{
                    // this.$message.error('表单有误！')
                }
            })
            
        },
        //跳转统计大屏
        // staticTo(){
        //     let routeData = this.$router.resolve({
        //         name: "real"
        //     });
        //     window.open(routeData.href, '_blank');
        // },
        //查询医院管理员
        getAdminInfo(hosp){ 
            if(hosp.hospSaId==''){
                this.flag=false;
                return;
            }
            else{
                this.flag=true;
            }
            this.$ajax.post(this.$domain.getAdmin,{
                userId:hosp.hospSaId
            }).then((ret)=>{
                this.$common.getConsole('hospDetail.vue——查询医院管理员',ret.data)
                var res=ret.data;
                if(res.code=="200"){
                    this.adminMsg=res.data
                    this.adminDialog=true
                }
                else{
                    this.$message.error('获取管理员信息失败！');
                }
            })
        },
        // 添加管理员
        saveAdmin(){
            this.$refs['addAdminForm'].validate((valid) => {
                if (valid) {
                    if(this.addAdminForm.password!=this.addAdminForm.passwordTwo){
                        this.$message.error('两次密码输入不一致！');
                        return;
                    }
                    this.loadingInstance=Loading.service({
                        text:'医院管理员创建中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    var obj={
                        hospId:this.hospMsg.hospId,
                        hospName:this.hospMsg.hospName,
                        userName:this.addAdminForm.docName,
                        userTel:this.addAdminForm.docPhone,
                        password:this.$common.pwd99(this.addAdminForm.password)
                    }
                    this.$ajax.post(this.$domain.addHospAdmin,obj)
                    .then((ret)=>{
                        this.loadingInstance.close();
                        var res=ret.data
                        if(res.code=="200"){
                            this.$message.success('创建成功！');
                            this.addAdminDialog=false
                            this.getHospDetail(this.hospMsg.hospId)
                        }
                        else if(res.code=="202"){
                            this.$message.error('手机号已存在，请检查手机号！');
                        }
                        else{
                            this.$message.error('创建失败！');
                        }
                    })
                    .catch(err=>{
                        this.loadingInstance.close();
                    })
                }else {
                    return false;
                }
            })
        },
        // 重置管理员密码
        resetPassword(){
            this.$prompt('请输入密码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern:/^[0-9A-Za-z]{6,}$/,
                inputErrorMessage:'密码由数字和字母组成，且不得小于6位',
                inputType:'password'
            }).then(({ value }) => {
                this.$ajax.post(this.$domain.resetAdminPwd,{
                    userId:this.hospMsg.hospSaId,
                    password:this.$common.pwd99(value)
                }).then((ret)=>{
                    this.$common.getConsole('hospDetail.vue——重置管理员密码',ret.data)
                    var res=ret.data
                    if(res.code=="200"){
                        this.$message.success('重置成功！');
                    }
                    else if(res.code=='502'){
                        this.$message.error('登录失败，请重新登录！');
                        this.$router.push({path:"/login"});
                    }
                    else{
                        this.$message.error('重置失败！');
                    }
                }).catch((err)=>{
                    this.$common.getConsole('hospDetail.vue——重置管理员密码catch',err)
                })

            }).catch((err)=>{
                this.$common.getConsole('hospDetail.vue——重置管理员密码--密码验证catch',err)
            })
        },
        //获取关联医院列表
        getHospList(page){
            this.$ajax.post(this.$domain.listParentHosp,{
                hospId:this.hospMsg.hospId,
                hospName:this.hospName,
                page:page,
                rows:this.rowsList
            })
            .then(ret=>{
                this.$common.getConsole('hospDetail.vue——获取下级医院列表',ret.data)
                if(ret.data.code==200){
                    this.hospList.body=ret.data.data.list;
                    this.hospList.count=ret.data.data.count;
                }
                else if(ret.data.code=='502'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //获取未配置医院列表
        getUnHospList(){
            console.log('查询未关联医院')
            if(this.addHosp.hospName==''){
                this.$message.error('请输入医院名称！');
                return;
            }
            var obj={
                hospId:this.hospMsg.hospId,
                hospName:this.addHosp.hospName
            }
            this.$ajax.post(this.$domain.notAssignedList,obj)
            .then(ret=>{
                this.$common.getConsole('hospDetail.vue——获取未配置的医院',ret.data);
                var res=ret.data
                if(res.code=="200"){
                    this.addHosp.body=res.data.list;
                }
            })
        },
        //添加上级医院
        addParentHosp(row){
            var obj={
                hospId:this.hospMsg.hospId,
                parentHospId:row.hospId
            }
            this.$ajax.post(this.$domain.addParentHosp,obj)
            .then((ret)=>{
                var res=ret.data
                if(res.code=="200"){
                    this.$message.success('添加成功！');
                    this.cancel();
                    this.getHospList();
                }
                else if(res.code=="202"){
                    this.$message.error("已添加转诊医院！");
                }
                else{
                    this.$message.error('添加失败！');
                }
            })
        },
        //禁用医院
        delParent(row){
            this.$confirm('禁用后，将不可再互相转诊，确定继续操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var obj={
                    hospId:this.hospMsg.hospId,
                    parentHospId:row.hospId
                }
                this.$ajax.post(this.$domain.disbaleParent,obj)
                .then((ret)=>{
                    this.$common.getConsole('hospDetail.vue——禁用转诊医院',ret.data);
                    var res=ret.data
                    if(res.code=="200"){
                        this.$message.success('禁用成功！');
                        this.getHospList(1)
                        this.cancel();
                    }
                    else{
                        this.$message.error('禁用失败！');
                    }
                })
            }).catch((error) => {
                console.log(error)
            });

        },
        //下级医院列表分页
        changePage(val){
            this.getHospList(val);
        },
        changeSizeL(val){
            this.rowsList=val;
            this.getHospList(val)
        },
        //取消
        cancel(){
            //医院编辑信息重置
            this.editHosp=false;
            this.editMsg={
                hospCode:'',
                hospName:'',
                hospAddr:'',
                hospRank:'',
                hospDesc:'',
                hospRegionAddr:'',
                hospAdminName:'',
                hospAdminTel:'',
                receiveName:'',
                receiveTel:'',
            }
            //医院账户修改
            this.editChar=false;
            this.editCharMsg={
                hospId:'',
                chargeStatus:'',
                standardPrice:'',
                chargeRule:{}
            }
            //下级医院添加
            this.addDialog=false,
            this.addHosp={
                hospName:'',
                body:[],
                count:0
            }
            //创建管理员
            this.addAdminDialog=false;
            this.addAdminForm={
                docName:'',
                docPhone:'',
                password:'',
                passwordTwo:''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#hospDetail{
    width:100%;
    min-width: 1200px;
    padding:0 10%;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    // padding: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    // box-sizing: border-box;
    .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    .box-card{
        width:100%;
        margin:20px auto;
        padding:20px;
        max-width:1600px;
        .title{
            font-size: 18px;
            margin-top:10px;
            margin-bottom:30px;
            text-align: left;
            color:#5c6bc0;
            font-weight: bold;
            padding:10px 10px;
            border-bottom:1px solid #5c6bc0;
            position: relative;
            .editMsg{
                position: absolute;
                display: inline-block;
                top:12px;
                right:20px;
                width:20px;
                height:20px;
                cursor: pointer;
            }
        }
        .list{
            display: flex;
            justify-content: flex-start;
            padding:10px 20px;
            box-sizing: border-box;
            font-size: 16px;
            color:#333;
            line-height: 30px;
            .keyWord{
                margin-right:20px;
                width:110px;
                text-align: right;
            }
            .contents{
                width:84%;
                text-align: left;
            }
            .el-radio-group{
                padding-top:10px;
                box-sizing: border-box;
            }
            .editPwd{
                color:#5c6bc0;
                margin-left:30px;
                cursor: pointer;
                font-size: 14px;
            }
        }
        .statePic{
            text-align:right;
            padding-right:30px;
            font-size:20px;
            color:#5c6bc0;
            cursor: pointer;
        }
        .list-right{
            text-align:right;
            padding:10px;
            box-sizing: border-box;
        }
        .jiaoyi{
            margin-left:20px;
            color:#5c6bc0;
            cursor: pointer;
        }
        .lineThrough{
            text-decoration:line-through
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/hospDetail.vue